/**
 * Component: M48 Timeline
 * 
 */
'use strict';

export class Timeline
{
  constructor()
  {
    this.selectors = {
      component:    $('.c-v4-m48-timeline'),
      slider:       $('.c-v4-m48-timeline--main'),
      slider_class: '.c-v4-m48-timeline--main',
      line:         $('.c-v4-m48-timeline--line-slider'),
      line_class:   '.c-v4-m48-timeline--line-slider',
      dot:          $('.c-v4-m48-timeline--line-dot'),
    };
  }

  init()
  {
    if ( ! this.selectors.component.length ) return;

    this.init_slick_carousel();
  }

  /**
   * Init slick carousel
   * 
   */
  init_slick_carousel()
  {
    this.selectors.component.each(function()
    {
      let _sliderLine = $(this).find('.c-v4-m48-timeline--line-slider');
      let _sliderMain = $(this).find('.c-v4-m48-timeline--main');
      let _childElements = $(this).find('.c-v4-m48-timeline--line-dot').children().length;

      $(this).on('init reInit', function(event, slick, currentSlide){
        $(this).find('.c-v4-m48-timeline--prev').addClass('inactive');
        $(this).find('.c-v4-m48-timeline--line').addClass('first');
      });

      $(this).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        if (nextSlide == 0) {
          $(this).find('.c-v4-m48-timeline--prev').addClass('inactive');
          $(this).find('.c-v4-m48-timeline--line').addClass('first');
        }
        else if (nextSlide == slick.slideCount - 1) {
          $(this).find('.c-v4-m48-timeline--next').addClass('inactive');
          $(this).find('.c-v4-m48-timeline--line').addClass('last');
        }
        else {
          $(this).find('.c-v4-m48-timeline--line').removeClass('last');
          $(this).find('.c-v4-m48-timeline--line').removeClass('first');
          $(this).find('.c-v4-m48-timeline--prev').removeClass('inactive');
          $(this).find('.c-v4-m48-timeline--next').removeClass('inactive');
        }

      });

      // Init main event slider
      $(_sliderMain).slick({
        arrows:         true,
        asNavFor:       _sliderLine,
        autoplay:       false,
        dots:           false,
        infinite:       false,
        nextArrow:      $(this).find('.c-v4-m48-timeline--next'),
        prevArrow:      $(this).find('.c-v4-m48-timeline--prev'),
        slidesToScroll: 1,
        slidesToShow:   1,
      });

      $(_sliderLine).slick({
          arrows:         false,
          asNavFor:       _sliderMain,
          dots:           false,
          focusOnSelect:  true,
          infinite:       false,
          slidesToShow:   _childElements,
          slidesToScroll: 1,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                centerMode:   true,
                infinite:     false,
                slidesToShow: 3
              }
            }
          ]
      });
    });
  }
}
